import React from 'react';
import './PilgrimServices.css';

const services = [
  {
    title: "Darshan Booking",
    description:
      "Easily book Darshan tickets online. Choose from Seva Darshan, Special Entry, or VIP Darshan.",
    icon: "fas fa-calendar-check",
  },
  {
    title: "Arjitha Sevas",
    description:
      "Participate in various sacred rituals and poojas. Suprabhatham, Thomala Seva, Archana, and more.",
    icon: "fas fa-star",
  },
  {
    title: "Prasadam & Laddus",
    description:
      "Order delicious Srivari Laddus and other prasadam online for delivery.",
    icon: "fas fa-gift",
  },
  {
    title: "Accommodation",
    description:
      "Book comfortable rooms and cottages near the temple for your peaceful stay.",
    icon: "fas fa-building",
  },
  {
    title: "Special Pujas",
    description:
      "Kalyanamastham, Sahasra Kalasabhishekam, and other special religious rites.",
    icon: "fas fa-users",
  },
  {
    title: "Daily Schedule",
    description:
      "View temple timings, daily rituals schedule, and important event calendars.",
    icon: "fas fa-clock",
  },
];

function PilgrimServices() {
  return (
    <section className="pilgrim-services section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-part-1">Pilgrim</span> <span className="title-part-2">Services</span>
          </h2>
        </div>

        <p className="section-subtitle text-center">
          Experience seamless devotion with our comprehensive online services.
          Book darshan, sevas, and accommodations from anywhere.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PilgrimServices;